import React from 'react';

function ComoFunciona(){
    return(
        <div className='container mx-auto py-14'>
            <div className='flex items-center justify-center my-12'>
                <h1 className='text-2xl font-bold font-times'>Método de transformación</h1>
            </div>

            <div className='flex items-center justify-center my-12'>
                <p className='text-xl  text-justify font-times mx-5'>
                    La mayoría de las personas y organizaciones intentan mejorar sus resultados cambiando solo las acciones externas.
                    Sin embargo, los verdaderos resultados sostenibles comienzan con una transformación interna.<br/>

                    Mi enfoque de trabajo se basa en un proceso estructurado que integra desarrollo personal, liderazgo y mentalidad estratégica, inspirado en principios enseñados por grandes referentes del crecimiento personal y liderazgo como Jim Rohn, Brian Tracy y Tony Robbins.<br/>

                    Este método está diseñado para ayudar tanto a <strong> personas, emprendedores, líderes y empresas</strong> a fortalecer su mentalidad, elevar su nivel de conciencia y desarrollar un enfoque más claro hacia sus objetivos y resultados.
                </p>
            </div>

            <div className='flex items-center justify-center my-12'>
                <h1 className='text-2xl font-bold font-times'>
                    Los tres pilares del método
                </h1>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-2  m-5 '>
                <div className='flex flex-col items-center justify-center my-12'>
                    <h2 className=' text-xl font-times'>
                        Claridad y conciencia
                    </h2>
                    <p className=' text-xl text-justify font-times mx-5'>
                        El primer paso para cualquier transformación es desarrollar claridad.
                        Trabajamos en identificar creencias limitantes, patrones de pensamiento y áreas que necesitan fortalecerse, para que la persona o el equipo pueda comprender dónde se encuentra y hacia dónde quiere avanzar.
                        Cuando hay claridad interior, las decisiones se vuelven más firmes y estratégicas.
                    </p>
                </div>
                <div className='flex flex-col items-center justify-center my-12'>
                    <h2 className=' text-xl font-times'>
                        Fortalecimiento de mentalidad y liderazgo
                    </h2>
                    <p className=' text-xl text-justify font-times mx-5'>
                        El crecimiento real ocurre cuando una persona fortalece su mentalidad.
                        En esta etapa se desarrollan principios de disciplina, responsabilidad personal, liderazgo y visión, elementos fundamentales tanto para el crecimiento individual como para el desarrollo de equipos y organizaciones.
                        Una mentalidad fuerte permite enfrentar desafíos, tomar mejores decisiones y sostener el progreso a largo plazo.
                    </p>
                </div>
            </div>

            <div className='flex flex-col items-center justify-center my-12'>
                <h2 className=' text-xl font-times'>
                    Acción consciente y resultados
                </h2>
                <p className=' text-xl text-justify mx-5 font-times'>
                    La transformación solo se vuelve real cuando se traduce en acción.
                    En esta etapa se enfocan los esfuerzos en aplicar lo aprendido, desarrollar hábitos productivos y construir estrategias que permitan generar resultados concretos en la vida personal, profesional o empresarial.
                    Porque cuando una persona transforma su mentalidad y actúa con claridad, los resultados comienzan a cambiar.
                </p>
            </div>

        </div>
    )
}

export default ComoFunciona;